import styles from './Modal.module.css'
import Header from '../../../../components/Header/Header'
import AnswersV3 from '../../../AnswersV3/AnswersV3'
import React, { useContext } from 'react'
import InsertChartIcon from '@mui/icons-material/InsertChart'

import { BuilderContext } from '../store/store.Builder'

function Modal({ windowWidth, windowHeight }) {
  const builderContext = useContext(BuilderContext)

  return (
    <div className={styles.modal}>
      <Header isAnswersResponse={true} />
      <div className={styles.content}>
        <div className={styles.message_warning}>
          <div className={styles.card}>
            {windowWidth < 767 && (
              <p>
                Pour accèder au Builder, la page doit avoir une largeur minimale
                de 767px.
              </p>
            )}
            {windowHeight < 600 && (
              <p>
                Pour accèder au Builder, la page doit avoir une hauteur minimale
                de 600px.
              </p>
            )}
          </div>
        </div>

        <a
          href={`/sandbox/${builderContext.url_code}/answers/`}
          className={styles.a__hover}
        >
          <div className={styles.card}>
            <div className={styles.card__header}>
              <div className={styles.icon__card}>
                <InsertChartIcon className={styles.my_icon} />
              </div>
            </div>
            <div className={styles.card__body}>
              <div className={styles.titre__card}>Réponses</div>
              <div className={styles.text__card}>
                Voir les réponses de ce formulaire
              </div>
              <hr className={styles.horizontal} />
            </div>
          </div>
        </a>
      </div>
    </div>
  )
}

export default Modal
